export default function reloadCachedPage() {
  window.addEventListener('pageshow', function (event) {
    // Verifica se a página foi carregada a partir do cache
    if (event.persisted || performance.getEntriesByType("navigation")[0].type === 'back_forward') {
      window.location.reload();
    }
  });
}